import { styled } from '@mui/material/styles';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import IconButton from '@mui/material/IconButton';

const MenuContainer = styled('div')({
  backgroundColor: '#633F31',
  display: 'flex',
  alignItems: 'center',
});

const MenuList = styled('ul')(({ theme }) => ({
  flexWrap: 'wrap',
  padding: '0px',
  listStyle: 'none',
  margin: '0 3vw 0 4vw',
  '& *': {
    color: '#fff',
  },
  [theme.breakpoints.down('md')]: {
    margin: '0 auto',
  },
}));

const MenuItem = styled('li')({
  fontFamily: 'Fjalla One',
  fontWeight: 400,
  fontSize: '26px',
  lineHeight: '33px',
  marginBottom: '28px',
  display: 'flex',
  alignItems: 'center',
});

const MenuLink = styled('a')({
  //   textDecoration: 'none',
  display: 'flex',
  alignItems: 'center',
  '&>svg': {
    marginLeft: '17px',
    with: '20px',
    height: '20px',
  },
});

const ArrowButton = styled(IconButton)({
  border: 'none',
  padding: '0',
  height: '33px',
  display: 'flex',
  alignItems: 'center',
  minWidth: 'auto',
  marginLeft: '21px',
});

const LandingMenu = (props) => {
  const { switchCover } = props;
  return (
    <MenuContainer>
      <MenuList>
        <MenuItem>
          <MenuLink href="/search">Find a Cafe</MenuLink>
          <ArrowButton
            onClick={() => {
              switchCover('cafe');
            }}
          >
            <ArrowRightAltIcon />
          </ArrowButton>
        </MenuItem>
        <MenuItem>
          <MenuLink href="/note">Explore Coffee Notes</MenuLink>
          <ArrowButton
            onClick={() => {
              switchCover('note');
            }}
          >
            <ArrowRightAltIcon />
          </ArrowButton>
        </MenuItem>

        <MenuItem>
          <MenuLink href="/signin">Login to the Realm</MenuLink>
        </MenuItem>

        <MenuItem>
          <MenuLink href="#">
            About Us
            <PlayCircleOutlineIcon />
          </MenuLink>
        </MenuItem>
      </MenuList>
    </MenuContainer>
  );
};

export default LandingMenu;
